export function getCurrentPageURL() {
  return window.location.pathname + window.location.search + window.location.hash;
}

export function getOrigin() {
  return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "")
}